import { render, staticRenderFns } from "./menuDetailEntity.vue?vue&type=template&id=c99c1504&scoped=true"
import script from "./menuDetailEntity.vue?vue&type=script&lang=js"
export * from "./menuDetailEntity.vue?vue&type=script&lang=js"
import style0 from "./menuDetailEntity.vue?vue&type=style&index=0&id=c99c1504&scoped=true&lang=scss"
import style1 from "./menuDetailEntity.vue?vue&type=style&index=1&id=c99c1504&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99c1504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99c1504')) {
      api.createRecord('c99c1504', component.options)
    } else {
      api.reload('c99c1504', component.options)
    }
    module.hot.accept("./menuDetailEntity.vue?vue&type=template&id=c99c1504&scoped=true", function () {
      api.rerender('c99c1504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformReport/components/menuDetailEntity.vue"
export default component.exports